import {store} from '@/store/store'

const inicializar = async function (to, next) {
  if (!store.getters['login/loaded']) {
    if (process.env.NODE_ENV === 'development' && !to.name.startsWith('incrustado')) {
      await store.dispatch('login/setVariablesSesion', {
        codigoAgrupacion: 'desdemo',
        idubapi: '1002100101'
      })
    } else if (to.name.startsWith('incrustado')) {
      try {
        await store.dispatch('login/setEntornoTrabajoIncrustado')
      } catch (e) {
        next({name: 'incrustado.mensajeError'})
        return false
      }
    }
    await store.dispatch('login/restaurarSesion')
    await store.dispatch('login/setLoaded', true)
    if ((window.errorSubdominioAgrupacion && window.codSubdominioAgrupacion) || (window.errorSubdominioAgrupacion && !store.getters['login/codSubdominioAgrupacion'])) {
      next({name: to.name.startsWith('incrustado') ? 'incrustado.mensajeError' : 'login.mensajeErrorAcceso'})
      return false
    } else if (to.name.startsWith('incrustado') && window.errorUsuarioComercial) {
      next({name: 'incrustado.mensajeError'})
      return false
    }
  }
  return true
}

const comprobarAuth = async function (to, next) {
  try {
    if (to.matched.some(route => route.meta.requiresAuth)) {
      if (store.getters['login/loggedIn'] && !store.getters['login/sessionChecked']) { // comprobar session
        store.dispatch('login/setCheckingSession', true)
        await store.dispatch('login/comprobarSesion')
        store.dispatch('login/setCheckingSession', false)
      }
      if (!store.getters['login/loggedIn']) { // comprobar que estoy logueado
        await store.dispatch('alerts/addNotLoggedIn')
        if (to.name.startsWith('incrustado')) {
          next({name: 'incrustado.mensajeError'})
        } else {
          next({name: 'loginParam', params: { codigoSubdominio: store.getters['login/codSubdominioAgrupacion'] }})
        }
        return false
      }
      if (store.getters['login/passwordUsoUnico'] &&
        to.name !== 'login.modificarPassword' && !to.name.startsWith('incrustado.')
      ) { // comprobar passwordUsoUnico
        next({ name: 'login.modificarPassword' })
        return false
      }
    }
    return true
  } catch (error) {
    await store.dispatch('alerts/addNotLoggedIn')
    next({name: 'loginParam', params: { codigoSubdominio: store.getters['login/codSubdominioAgrupacion'] }})
    return false
  }
}

const comprobarPermisos = async function (to, next) {
  if (to.matched.some(route =>
    route.meta.roles && (
      store.getters['login/usuario'].roles == null ||
      !store.getters['login/usuario'].roles.some(rol => route.meta.roles.includes(rol))
    )
  )) {
    store.dispatch('alerts/addTranslated', {color: 'error', texto: 'router.sinPermiso'})
    next({name: 'home'})
    return false
  } else {
    return true
  }
}

const comprobarTextos = async function (to) {
  if (!store.getters['textos/loaded'] && !to.name.startsWith('login')) {
    store.dispatch('textos/setLoading', true)
    await store.dispatch('textos/loadAll', to.name)
    store.dispatch('textos/setLoading', false)
  }
  return true
}


const autologinCRM = async function (to, next) {
  let parametros = JSON.parse(to.query.jsondata).parametros
  try {
    await store.dispatch('login/autoLoginCRM', {
      id_reserva: parametros.id_reserva,
      id_bd_prinex: parametros.id_bd_prinex,
      cod_cli: parametros.cod_cli,
      token: parametros.token,
      simplificada: false
    })
    await store.dispatch('reservas/_id/load',parametros.id_reserva)
    let moduloOrden = store.getters['modulosOrdenes/getActual']
    if (moduloOrden.simplificada == 0) {
      next({name: 'reservas.id', params: { id: parametros.id_reserva, skip: true }})
    } else {
      next({name: 'reservas.id.simplificada', params: { id: parametros.id_reserva }})
    }

    // next({name: 'reservas.id', params: { id: parametros.id_reserva, skip: true }})
  } catch (error) {
    next({name: 'home'})
  }  
}


const importarConstantes = async function (to) {
  if (!store.getters['constantes/loaded'] && !to.name.startsWith('login')) {
    store.dispatch('constantes/setLoading', true)
    await store.dispatch('constantes/loadAll', to.name)
    store.dispatch('constantes/setLoading', false)
  }
  return true
}

const beforeEach = async function (to, from, next) {
  store.dispatch('login/setCheckingSession', false)
  store.dispatch('login/setComprobandoNumReservas', false)
  store.dispatch('textos/setLoading', false)
  store.dispatch('constantes/setLoading', false)
  if (to.name.startsWith('reservaCRM')) {
    await autologinCRM(to, next)
  } else {
    if (
      await inicializar(to, next) &&
      await comprobarAuth(to, next) &&
      await comprobarPermisos(to, next) &&
      await comprobarTextos(to, next) &&
      await importarConstantes(to, next)
    ) {
      next()
    }
  }
 
}

export default beforeEach



// WEBPACK FOOTER //
// ./src/router/beforeEach.js